import API from "@/api";

const IS_ABSENCE = "IS_ABSENCE";

export default {
  namespaced: true,

  state: {
    absence: false
  },

  actions: {
    setAbsence({ commit }, value) {
      commit(IS_ABSENCE, value);
    },

    async createRescheduleTicket({ state }, payload) {
      try {
        return await API.Freshdesk.rescheduleTicket(payload, state.absence);
      } catch (e) {
        throw e;
      }
    },

    async createCancellationTicket({ state }, payload) {
      try {
        return await API.Freshdesk.cancellationTicket(payload, state.absence);
      } catch (e) {
        throw e;
      }
    },

    async createCreditHoursTicket({ state }, payload) {
      try {
        return await API.Freshdesk.creditHoursTicket(payload, state.absence);
      } catch (e) {
        throw e;
      }
    }
  },

  mutations: {
    [IS_ABSENCE](state, value) {
      state.absence = value;
    }
  },

  getters: {}
};



// WEBPACK FOOTER //
// ./src/store/modules/freshdesk.js